import React, { Component } from 'react';
import Radio from './Radio'

export default class Head extends Component {
	render() {
		const {ans, cb, on} = this.props

		return <div style={{...this.props.style, 
			display:"flex",
			alignItems: "center",
			cursor:"pointer"
			// backgroundColor: "rgba(0,0,0,0.5)"
		}} onClick={cb}>
			<Radio on={on} style={{		
			}}/>

			<span> {ans} </span>
		</div>
		
	}

}



// WEBPACK FOOTER //
// ./src/dComp/shared/AmcAns.js